import { promiseWrapper } from 'utils/promise'
import {
  ExchangeTransferCalculate,
  CurrencyExchangeDetails,
  ChosenItemTransfer,
} from 'models/exchange-transfer-calculate'

declare const USER_BASE_URL_WT: string

export const exchangeTransfer = async (
  exchangeDetails: CurrencyExchangeDetails,
  chosenTransfer: ChosenItemTransfer = {},
  originCountry?: string,
  destinationCountry?: string,
  abortController?: AbortController,
  headers?: Record<string, string>,
): Promise<ExchangeTransferCalculate> => {
  const { baseAmount, counterAmount, baseCurrency, counterCurrency, discountRate, withoutTransferFee } = exchangeDetails
  const { chosenItemTransferFee = '', chosenItemTransferType = '' } = chosenTransfer

  const fromCountry = originCountry || 'PL'
  const toCountry = destinationCountry || 'PL'
  const discount = discountRate ? String(discountRate) : undefined

  const queryParams = new URLSearchParams(
    Object.fromEntries(
      Object.entries({
        unit: '3', // '3' is the unit for the WT service
        bought_amount: baseAmount,
        sold_amount: counterAmount,
        sold_currency: counterCurrency,
        bought_currency: baseCurrency,
        from_country: fromCountry,
        to_country: toCountry,
        transfer_type_fee: chosenItemTransferFee,
        transfer_type: chosenItemTransferType,
        discount_rate: discount,
        without_transfer_fee: withoutTransferFee ? 'true' : undefined,
      }).filter((entry): entry is [string, string] => entry[1] !== undefined && entry[1] !== ''),
    ),
  )

  const url = `${USER_BASE_URL_WT}/api/public/exchangeTransferCalculate?${queryParams.toString()}`

  return await promiseWrapper<ExchangeTransferCalculate, null>(url, 'GET', null, headers, abortController?.signal)
}
